import { get as apiGet } from "./API";

export async function getIcs(id: string) {
  return apiGet(`/reservations/${id}/ics`, { responseType: "text" });
}
